import { LOAI_DINH_MUC } from '@/core/constants/const';
import { AddVatTuItemsFor } from '@/core/enums/addVatTuItemsFor.enum';
import type {
  IPhieuXuatKhoSuppliesQuantityRow,
  LoaiDinhMucApiParam,
  PhieuXuatKhoLoaiPhieu,
} from './types';

export const PHIEU_XUAT_KHO_LOAI = {
  BBGT: 0,
  TAM_XUAT: 1,
  THU_HOI: 2,
} as const satisfies Record<string, PhieuXuatKhoLoaiPhieu>;

export const LOAI_DINH_MUC_API = {
  DINH_MUC_CO_DINH: 1,
  NGOAI_DINH_MUC: 2,
} as const satisfies Record<string, LoaiDinhMucApiParam>;

export function loaiDinhMucToApiParam(
  loaiDinhMuc: LOAI_DINH_MUC
): LoaiDinhMucApiParam {
  if (loaiDinhMuc === LOAI_DINH_MUC.NGOAI_DINH_MUC) {
    return LOAI_DINH_MUC_API.NGOAI_DINH_MUC;
  }

  return LOAI_DINH_MUC_API.DINH_MUC_CO_DINH;
}

export function resolveNgoaiDinhMucExportMax(
  row: Pick<
    IPhieuXuatKhoSuppliesQuantityRow,
    'chenh_lech' | 'so_luong_goi_y' | 'so_luong_trong_kho_ban_dau'
  >,
  fallbackChenhLech: number
): number {
  const chenhLech = Math.max(0, row.chenh_lech ?? fallbackChenhLech);

  if (row.so_luong_goi_y != null && row.so_luong_goi_y >= 0) {
    return row.so_luong_goi_y;
  }

  return Math.min(chenhLech, row.so_luong_trong_kho_ban_dau);
}

export function getLoaiDinhMucLabel(loaiDinhMuc?: 1 | 2 | null): string {
  if (loaiDinhMuc === LOAI_DINH_MUC_API.DINH_MUC_CO_DINH) {
    return 'Trong định mức';
  }

  if (loaiDinhMuc === LOAI_DINH_MUC_API.NGOAI_DINH_MUC) {
    return 'Ngoài định mức';
  }

  return '-';
}

export function loaiDinhMucFromQuery(queryValue?: string): LOAI_DINH_MUC {
  const normalized = queryValue?.trim().toLowerCase();

  if (normalized === 'ngoai-dinh-muc') {
    return LOAI_DINH_MUC.NGOAI_DINH_MUC;
  }

  if (normalized === 'trong-dinh-muc') {
    return LOAI_DINH_MUC.DINH_MUC_CO_DINH;
  }

  return LOAI_DINH_MUC.DINH_MUC_CO_DINH;
}

export function getAddVatTuUseFor(
  loaiPhieu: PhieuXuatKhoLoaiPhieu
): AddVatTuItemsFor {
  if (loaiPhieu === PHIEU_XUAT_KHO_LOAI.THU_HOI) {
    return AddVatTuItemsFor.PHIEU_XUAT_KHO_VAT_TU_THU_HOI;
  }

  return AddVatTuItemsFor.PHIEU_XUAT_KHO;
}
